export default {
  title: 'Operation Log',
  timeline: 'Operation Timeline',
  noRecords: 'No operation records',
  loadMore: 'Load more',
  related: 'Related',
  operation: 'Action',
  operator: 'Operator',
  operateTime: 'Time',
  module: 'Module',
  detail: 'Detail',
  create: 'Create',
  update: 'Update',
  delete: 'Delete',
  login: 'Login',
  logout: 'Logout',
  lock: 'Lock',
  unlock: 'Unlock',
  match: 'Match',
  import: 'Import',
  export: 'Export',
  action: {
    BIZ_CREATED: 'Created business order',
    BIZ_UPDATED: 'Updated business order',
    BIZ_UPDATED_NO_CHANGE: 'Updated (no changes)',
    BIZ_DELETED: 'Deleted business order',
    BIZ_CANCEL_REQUESTED: 'Cancellation requested',
    BIZ_CANCEL_APPROVED: 'Cancellation approved',
    BIZ_CANCEL_REJECTED: 'Cancellation rejected',
    BIZ_CANCELLED: 'Business order cancelled',
    BIZ_COPIED: 'Copied to new',
    BIZ_SUBMITTED: 'Submitted for booking',
    BIZ_REVERTED: 'Reverted to draft',
    BIZ_VIEWED_BY_OPS: 'Viewed by OPS',
    BIZ_PARTIAL_UPDATED: 'Partially updated business order',
    BIZ_CARGO_CHANGED: 'Cargo changed',
    BIZ_MATCHED_PO: 'Matched product order',
    BIZ_MATCHED_MAWB: 'Matched MAWB',
    BIZ_UNMATCHED_PO: 'Unmatched product order',
    BIZ_WAREHOUSE_BACKFILLED: 'Backfilled actual warehouse data',
    BIZ_WAREHOUSE_UPDATED: 'Updated warehouse data',
    BIZ_WAREHOUSE_HAWB_ADDED: 'Entered HAWB information',
    BIZ_WAREHOUSE_HAWB_UPDATED: 'Updated HAWB information',
    BIZ_WAREHOUSE_STATUS_CHANGED: 'Warehouse status changed',
    BIZ_FEE_CONFIRMED: 'Fee confirmed, order completed',
    BIZ_LOCKED: 'Locked',
    BIZ_UNLOCKED: 'Unlocked',
    BIZ_BUBBLE_APPLIED: 'Applied bubble quote',
    BIZ_BUBBLE_CANCELLED: 'Cancelled bubble quote',
    BIZ_BASE_RATE_SET: 'Set base rate',
    BIZ_BASE_RATE_UPDATED: 'Updated base rate',
    BIZ_CHANGE_REQUESTED: 'Change requested',
    BIZ_CHANGE_APPROVED: 'Change approved',
    BIZ_CHANGE_REJECTED: 'Change rejected',
    BIZ_HAWB_CREATED: 'HAWB created',
    BIZ_HAWB_CANCELLED: 'HAWB cancelled',
    BIZ_COMPLETED: 'Confirmed completion',
    BIZ_UNCOMPLETED: 'Uncompleted',
    BIZ_AUTO_COMPLETED: 'Auto-completed (ETD+10 days)',
    BIZ_MATCHED: 'Biz order matched',
    BIZ_DETACHED: 'Biz order detached',
    BIZ_MATCH_STATUS_CHANGED: 'Match status changed',
    BIZ_DISSOLVED: 'Dissolved',
    BIZ_CASCADED_LOCKED: 'Cascaded locked',
    BIZ_CASCADED_UNLOCKED: 'Cascaded unlocked',
    BIZ_WAREHOUSE_ADJUSTED: 'Warehouse adjusted',
    BIZ_POOL_CHANGED: 'Switched pool',
    BIZ_POOL_RESERVED: 'Reserved pool',
    BIZ_POOL_RELEASED: 'Released pool',
    PO_CREATED: 'Created product order',
    PO_UPDATED: 'Updated product order',
    PO_UPDATED_NO_CHANGE: 'Updated (no changes)',
    PO_CASCADED_UPDATED: 'Cascaded update from business order',
    PO_NUMBER_CHANGED: 'Changed product order number',
    BIZ_PRODUCT_ORDER_NO_CHANGED: 'Linked product order number changed',
    PO_PRE_SALE: 'Confirmed pre-sale',
    PO_LOCKED: 'Locked product order',
    PO_UNLOCKED: 'Unlocked product order',
    PO_DISSOLVED: 'Dissolved product order',
    PO_DELETED: 'Deleted product order',
    PO_ATD_FILLED: 'ATD filled',
    PO_ATA_FILLED: 'ATA filled, status changed to arrived',
    PO_ARCHIVED: 'Auto archived',
    PO_ROLLBACK_LOCKED: 'Rolled back to locked',
    MAWB_CREATED: 'Created MAWB',
    MAWB_UPDATED: 'Updated MAWB',
    MAWB_DELETED: 'Revoked MAWB',
    HAWB_CREATED: 'HAWB created',
    HAWB_UPDATED: 'Updated HAWB',
    HAWB_CANCELLED: 'HAWB cancelled',
    HAWB_AIRLINE_BACKFILLED: 'Airline data backfilled',
    HAWB_DIFF_HANDLED: 'Diff handled',
    AGREEMENT_WEIGHT_OCCUPIED: 'Product order linked to this agreement order',
    AGREEMENT_WEIGHT_RELEASED: 'Product order adjusted or removed its agreement link',
    AGREEMENT_WEIGHT_INCREASED: 'Product order agreement ULDs updated',
    AGREEMENT_PRODUCT_ORDER_LINKED: 'Product order linked to this agreement order',
    AGREEMENT_PRODUCT_ORDER_UPDATED: 'Linked product order updated',
    AGREEMENT_PRODUCT_ORDER_UNLINKED: 'Product order unlinked from this agreement order',
    AGREEMENT_CREATED: 'Created agreement order',
    AGREEMENT_UPDATED: 'Updated agreement order',
    AGREEMENT_DELETED: 'Deleted agreement order',
    AGREEMENT_TOGGLED: 'Toggled agreement order',
    AGREEMENT_STATUS_CHANGED: 'Agreement status changed',
    FRAMEWORK_AGREEMENT_CREATED: 'Created agreement',
    FRAMEWORK_AGREEMENT_UPDATED: 'Updated agreement',
    FRAMEWORK_AGREEMENT_TOGGLED: 'Activated/deactivated agreement',
    FRAMEWORK_AGREEMENT_ORDER_LINKED: 'Agreement order linked',
    FRAMEWORK_AGREEMENT_ORDER_UNLINKED: 'Agreement order unlinked',
  },
  field: {
    ratio: 'Bubble ratio',
    rate: 'Base rate',
    currency: 'Currency',
    oldRate: 'Old base rate',
    reason: 'Reason',
    fieldName: 'Field',
    originalValue: 'Old value',
    newValue: 'New value',
    rejectReason: 'Reject reason',
    enteredBy: 'Entered by',
    pieces: 'Pieces',
    weight: 'Weight',
    volume: 'Volume',
    chargeableWeight: 'Chargeable weight',
    oldStatus: 'Old status',
    newStatus: 'New status',
    hawbNo: 'HAWB No.',
    hasHawb: 'HAWB option',
    oldHasHawb: 'Previous HAWB option',
    oldHawbNo: 'Previous HAWB No.',
    issueDate: 'Issue date',
    shipper: 'Shipper',
    consignee: 'Consignee',
    detailedDescription: 'Cargo description',
    mawbId: 'MAWB ID',
    bizOrderNo: 'Biz Order No.',
    mawbNo: 'MAWB No.',
    handling: 'Handling',
    diffStatus: 'Diff status',
    changeDesc: 'Change desc',
    sourceBizOrderNo: 'Source order no.',
    airlinePieces: 'Airline pieces',
    airlineWeight: 'Airline weight',
    airlineVolume: 'Airline volume',
    atd: 'ATD',
    ata: 'ATA',
    etd: 'ETD',
    affectedBizCount: 'Affected orders',
    oldPieces: 'Old pieces',
    oldWeight: 'Old weight',
    oldVolume: 'Old volume',
    oldChargeableWeight: 'Old chargeable wt',
    agreementNo: 'Agreement No.',
    agreementEntrustNo: 'Agreement Entrust No.',
    productOrderNo: 'Product Order No.',
    newWeight: 'New occupied wt',
    agreementRemaining: 'Agreement remaining',
    customerName: 'Customer name',
    customerCode: 'Customer code',
    customerSource: 'Customer source',
    legalEntityRelation: 'Legal entity',
    bookedPieces: 'Booked pieces',
    bookedWeight: 'Booked weight',
    bookedVolume: 'Booked volume',
    sellRate: 'Sell rate',
    sellCurrency: 'Sell currency',
    salesBaseRate: 'Sales base rate',
    documentFee: 'Document fee',
    infoTransmissionFee: 'Info fee',
    manifestFee: 'Manifest fee',
    otherSurcharge: 'Other surcharge',
    flightNo: 'Flight No.',
    flightDate: 'Flight date',
    departure: 'Departure',
    destination: 'Destination',
    goodsName: 'Goods name',
    goodsNameEn: 'Goods name (EN)',
    specialHandling: 'Special handling',
    packagingType: 'Packaging type',
    remark: 'Remark',
    old_customerName: 'Old customer name',
    old_customerCode: 'Old customer code',
    old_customerSource: 'Old customer source',
    old_legalEntityRelation: 'Old legal entity',
    old_pieces: 'Old pieces',
    old_weight: 'Old weight',
    old_volume: 'Old volume',
    old_bookedPieces: 'Old booked pieces',
    old_bookedWeight: 'Old booked weight',
    old_bookedVolume: 'Old booked volume',
    old_sellRate: 'Old sell rate',
    old_sellCurrency: 'Old sell currency',
    old_salesBaseRate: 'Old sales base rate',
    old_documentFee: 'Old document fee',
    old_infoTransmissionFee: 'Old info fee',
    old_manifestFee: 'Old manifest fee',
    old_otherSurcharge: 'Old other surcharge',
    old_flightNo: 'Old flight no.',
    old_flightDate: 'Old flight date',
    old_departure: 'Old departure',
    old_destination: 'Old destination',
    old_goodsName: 'Old goods name',
    old_goodsNameEn: 'Old goods name (EN)',
    old_specialHandling: 'Old special handling',
    old_packagingType: 'Old packaging type',
    old_remark: 'Old remark',
    noChange: 'No change',
    bubbleRatio: 'Bubble ratio',
    effectiveSellRate: 'Effective sell rate',
    oldSellRate: 'Old sell rate',
    origin: 'Origin',
    transportMode: 'Transport mode',
    productType: 'Product type',
    agreedPalletWeight: 'Agreed pallet wt',
    actualPalletWeight: 'Actual pallet wt',
    palletType: 'Pallet type',
    agreedPalletCount: 'Agreed pallet count',
    actualPalletCount: 'Actual pallet count',
    trunkRate: 'Trunk rate',
    trunkCostCurrency: 'Trunk cost currency',
    trunkCostSurcharge: 'Trunk surcharge',
    defaultTrunkRate: 'Default trunk rate',
    old_etd: 'Old ETD',
    old_eta: 'Old ETA',
    old_transportMode: 'Old transport mode',
    old_productType: 'Old product type',
    old_agreedPalletWeight: 'Old agreed pallet wt',
    old_actualPalletWeight: 'Old actual pallet wt',
    old_palletType: 'Old pallet type',
    old_agreedPalletCount: 'Old agreed pallet count',
    old_actualPalletCount: 'Old actual pallet count',
    old_trunkRate: 'Old trunk rate',
    old_trunkCostCurrency: 'Old trunk cost currency',
    old_trunkCostSurcharge: 'Old trunk surcharge',
    old_defaultTrunkRate: 'Old default trunk rate',
    old_region: 'Old region',
    region: 'Region',
    receivable_added: 'AR added',
    receivable_removed: 'AR removed',
    receivable_modified: 'AR modified',
    receivable_added_detail: 'AR added detail',
    receivable_removed_detail: 'AR removed detail',
    receivable_modified_detail: 'AR modified detail',
    localCost_added: 'AP added',
    localCost_removed: 'AP removed',
    localCost_modified: 'AP modified',
    localCost_added_detail: 'AP added detail',
    localCost_removed_detail: 'AP removed detail',
    localCost_modified_detail: 'AP modified detail',
    uldType: 'ULD type',
    oldUldType: 'Old ULD type',
    newUldType: 'New ULD type',
    affectedAgreementOrderCount: 'Affected agreement orders',
    sourceAgreementNo: 'Source agreement',
    oldAgreementNo: 'Previous agreement',
    newAgreementNo: 'New agreement',
    // Business order editable fields
    status: 'Status',
    salesOwner: 'Sales owner',
    customsType: 'Customs type',
    deliveryTerms: 'Delivery terms',
    contactName: 'Contact',
    contactPhone: 'Contact phone',
    contactAddress: 'Contact address',
    customerRemark: 'Customer remark',
    clientReferenceNo: 'Client ref. no.',
    contractType: 'Contract type',
    customerType: 'Customer type',
    customerLevel: 'Customer level',
    cargoType: 'Cargo type',
    packageType: 'Package type',
    temperatureReq: 'Temperature requirement',
    stackDirection: 'Stack direction',
    tradeTerms: 'Trade terms',
    finalDestination: 'Final destination',
    plannedWorkDate: 'Planned work date',
    requiredDeliveryDate: 'Required delivery date',
    flightNoOps: 'Flight No.',
    cargoDescription: 'Cargo description',
    specialRemark: 'Special remark',
    paymentMethod: 'Payment method',
    paymentTerms: 'Payment terms',
    taxFlag: 'Tax flag',
    hawbPrealertDeclared: 'HAWB pre-alert declared',
    shippingTerms: 'Shipping terms',
    serviceItems: 'Service items',
    orderCategory: 'Order category',
    shipperName: 'Shipper name',
    consigneeName: 'Consignee name',
    sellWeight: 'Chargeable weight',
    old_status: 'Previous status',
    old_salesOwner: 'Previous sales owner',
    old_customsType: 'Previous customs type',
    old_deliveryTerms: 'Previous delivery terms',
    old_contactName: 'Previous contact',
    old_contactPhone: 'Previous contact phone',
    old_contactAddress: 'Previous contact address',
    old_customerRemark: 'Previous customer remark',
    old_clientReferenceNo: 'Previous client ref. no.',
    old_contractType: 'Previous contract type',
    old_customerType: 'Previous customer type',
    old_customerLevel: 'Previous customer level',
    old_cargoType: 'Previous cargo type',
    old_packageType: 'Previous package type',
    old_temperatureReq: 'Previous temperature req.',
    old_stackDirection: 'Previous stack direction',
    old_tradeTerms: 'Previous trade terms',
    old_finalDestination: 'Previous final destination',
    old_plannedWorkDate: 'Previous planned work date',
    old_requiredDeliveryDate: 'Previous required delivery date',
    old_flightNoOps: 'Previous flight no.',
    old_cargoDescription: 'Previous cargo description',
    old_specialRemark: 'Previous special remark',
    old_paymentMethod: 'Previous payment method',
    old_paymentTerms: 'Previous payment terms',
    old_taxFlag: 'Previous tax flag',
    old_hawbPrealertDeclared: 'Previous HAWB pre-alert declared',
    old_shippingTerms: 'Previous shipping terms',
    old_serviceItems: 'Previous service items',
    old_orderCategory: 'Previous order category',
    old_shipperName: 'Previous shipper name',
    old_consigneeName: 'Previous consignee name',
    old_sellWeight: 'Previous chargeable weight',
    old_singleWeight: 'Previous single weight',
    old_singleLength: 'Previous single length',
    old_singleWidth: 'Previous single width',
    old_singleHeight: 'Previous single height',
    old_sellRate: 'Previous sell rate',
    // Product order cascaded update (biz order changes affecting PO aggregates)
    causeBizOrderNo: 'Source business order no.',
    causeAction: 'Cause',
    matchedBizCount: 'Matched orders',
    pendingWarehouseCount: 'Pending warehouse',
    warehousedCount: 'Warehoused',
    mawbCount: 'MAWB count',
    usedWeight: 'Used weight',
    usedGrossWeight: 'Used gross weight',
    usedVolume: 'Used volume',
    standardChargeableWeightTotal: 'Std chargeable wt total',
    totalGrossWeightCapacity: 'Gross weight capacity',
    totalVolumeCapacity: 'Volume capacity',
    remainingSaleableWeight: 'Remaining saleable wt',
    utilizationRate: 'Utilization rate',
    salesBaseTotalCost: 'Sales base total cost',
    lineProfit: 'Line profit',
    totalRevenue: 'Total revenue',
    mawbPayableTotal: 'MAWB payable total',
    companyProfit: 'Company profit',
    changeAlert: 'Change alert',
    isAlert: 'Alert',
    old_matchedBizCount: 'Previous matched orders',
    old_pendingWarehouseCount: 'Previous pending warehouse',
    old_warehousedCount: 'Previous warehoused',
    old_mawbCount: 'Previous MAWB count',
    old_usedWeight: 'Previous used weight',
    old_usedGrossWeight: 'Previous used gross weight',
    old_usedVolume: 'Previous used volume',
    old_standardChargeableWeightTotal: 'Previous std chargeable wt total',
    old_totalGrossWeightCapacity: 'Previous gross weight capacity',
    old_totalVolumeCapacity: 'Previous volume capacity',
    old_remainingSaleableWeight: 'Previous remaining saleable wt',
    old_utilizationRate: 'Previous utilization rate',
    old_salesBaseTotalCost: 'Previous sales base total cost',
    old_lineProfit: 'Previous line profit',
    old_totalRevenue: 'Previous total revenue',
    old_mawbPayableTotal: 'Previous MAWB payable total',
    old_companyProfit: 'Previous company profit',
    old_changeAlert: 'Previous change alert',
    old_isAlert: 'Previous alert',
  },
}
